import { z } from 'zod';
import { PasswordSchema } from './password.schema.js';
/**
 * "Forgot password?" The answer is the same whether or not the address has an
 * account, so the only thing validated here is that it looks like an address.
 */
export const ForgotPasswordSchema = z.object({
    email: z.string().trim().email('Enter a valid email address').max(255)
});
/** Redeem a reset link: the same password rules as signup. */
export const ResetPasswordSchema = z.object({
    token: z.string().min(1, 'Reset token is required').max(200),
    password: PasswordSchema
});
